import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleTypographyProps", "subtitle", "subtitleTypographyProps", "startAction", "endAction", "className"];
import { AppBar, Grid, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { ColorDynamic } from "../theme/Color.js";
import { VisibilityObserver } from "../utils/VisibilityObserver.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  appBar: {
    '&&': {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      transition: theme.transitions.create(['border-color']),
      '&:not($appBarSticky)': {
        borderBottomColor: ColorDynamic.Transparent
      }
    }
  },
  appBarSticky: {},
  toolbar: {
    '&.MuiToolbar-gutters': {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4)
      }
    }
  },
  startAction: {
    marginRight: theme.spacing(0.5),
    '& .MuiIconButton-edgeStart': {
      marginLeft: theme.spacing(-2)
    }
  },
  endAction: {
    marginLeft: theme.spacing(0.5),
    '& .MuiIconButton-edgeEnd': {
      marginRight: theme.spacing(-2)
    }
  }
}), {
  name: 'SD-DrawerTitle'
});
/** @deprecated Use `<AppDrawer>` instead. */
export var DrawerTitle = /*#__PURE__*/forwardRef((_ref, appBarRef) => {
  var {
      title,
      titleTypographyProps,
      subtitle,
      subtitleTypographyProps,
      startAction,
      endAction,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  return /*#__PURE__*/_jsx(VisibilityObserver, {
    render: _ref2 => {
      var {
        ref,
        visibility
      } = _ref2;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          ref: ref
        }), /*#__PURE__*/_jsx(AppBar, _objectSpread(_objectSpread({}, props), {}, {
          ref: appBarRef,
          position: "sticky",
          className: clsx(styles.appBar, className, {
            [styles.appBarSticky]: visibility === 'invisible'
          }),
          children: /*#__PURE__*/_jsx(Toolbar, {
            className: styles.toolbar,
            children: /*#__PURE__*/_jsxs(Grid, {
              container: true,
              direction: "column",
              children: [/*#__PURE__*/_jsx(Grid, {
                item: true,
                children: /*#__PURE__*/_jsxs(Grid, {
                  container: true,
                  alignItems: "center",
                  children: [!!startAction && /*#__PURE__*/_jsx(Grid, {
                    item: true,
                    className: styles.startAction,
                    children: startAction
                  }), /*#__PURE__*/_jsx(Grid, {
                    item: true,
                    xs: true,
                    zeroMinWidth: true,
                    children: /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
                      variant: "h3",
                      noWrap: true
                    }, titleTypographyProps), {}, {
                      children: title
                    }))
                  }), !!endAction && /*#__PURE__*/_jsx(Grid, {
                    item: true,
                    className: styles.endAction,
                    children: endAction
                  })]
                })
              }), /*#__PURE__*/_jsx(Grid, {
                item: true,
                children: !!subtitle && /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
                  variant: "body2",
                  noWrap: true
                }, subtitleTypographyProps), {}, {
                  children: subtitle
                }))
              })]
            })
          })
        }))]
      });
    }
  });
});
if (process.env.NODE_ENV !== "production") DrawerTitle.displayName = "DrawerTitle";